// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodProjectId } from './FoodProject';
import { foodTastingImageStatus } from './FoodTastingImageStatus';
import { foodTastingImageKind } from './FoodTastingImageKind';
import { foodTastingImageTheme } from './FoodTastingImageTheme';
import { fileStorageId } from './FileStorage';
import { operatorId } from './Operator';
import { z } from 'zod';
export const foodTastingImageVariantId = (z.number());
export const foodTastingImageVariant = z.object({
    id: foodTastingImageVariantId,
    project_id: foodProjectId,
    run: z.string(),
    status: foodTastingImageStatus,
    step: z.string().nullable(),
    error: z.string().nullable(),
    scene: z.string(),
    kind: foodTastingImageKind,
    theme: foodTastingImageTheme,
    model: z.string(),
    prompt: z.string(),
    recipe: z.unknown(),
    render_file_id: fileStorageId.nullable(),
    image_file_id: fileStorageId.nullable(),
    drift: z.number().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
});
export const foodTastingImageVariantInitializer = z.object({
    id: foodTastingImageVariantId.optional(),
    project_id: foodProjectId,
    run: z.string(),
    status: foodTastingImageStatus.optional(),
    step: z.string().optional().nullable(),
    error: z.string().optional().nullable(),
    scene: z.string(),
    kind: foodTastingImageKind,
    theme: foodTastingImageTheme,
    model: z.string(),
    prompt: z.string(),
    recipe: z.unknown(),
    render_file_id: fileStorageId.optional().nullable(),
    image_file_id: fileStorageId.optional().nullable(),
    drift: z.number().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
export const foodTastingImageVariantMutator = z.object({
    id: foodTastingImageVariantId.optional(),
    project_id: foodProjectId.optional(),
    run: z.string().optional(),
    status: foodTastingImageStatus.optional(),
    step: z.string().optional().nullable(),
    error: z.string().optional().nullable(),
    scene: z.string().optional(),
    kind: foodTastingImageKind.optional(),
    theme: foodTastingImageTheme.optional(),
    model: z.string().optional(),
    prompt: z.string().optional(),
    recipe: z.unknown().optional(),
    render_file_id: fileStorageId.optional().nullable(),
    image_file_id: fileStorageId.optional().nullable(),
    drift: z.number().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FoodTastingImageVariant.js.map